export default __webpack_public_path__ + "static/media/hamburger.07089ff4.svg";